'use client';

import { useEffect } from 'react';
import { useStreamingStore } from '@/store/streaming';
import { CricketMatchModel, MatchModelBase, MatchModelUnion } from '@nf/types/odds';
import { StreamingBase } from '../streaming-base';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { streamingService } from '@/services/streaming.service';
import { useAccountInfo } from '@/hooks/query/account';

export const IframeStreaming = ({ match }: { match?: MatchModelBase }) => {
	const [
		streamingSrc,
		channelList,
		streamingUrl,
		streamingType,
		setStreamingUrl,
		streamingMatchId,
		isRefresh,
		setIsLoading
	] = useStreamingStore(
		state => [
			state.streamingSrc,
			state.channelList,
			state.streamingUrl,
			state.streamingType,
			state.setStreamingUrl,
			state.streamingMatchId,
			state.isRefresh,
			state.setIsLoading
		]
	);
	const { user } = useAccountInfo();
	const { SiteConfigsData } = useGetSiteConfigs();
	const { hasDecimalWidgets } = streamingService.getVideoOptions(match as MatchModelUnion, false, SiteConfigsData, user);
	const STREAMING_URL_LIST = {
		DECIMAL_WIDGETS: SiteConfigsData?.DecimalWidgetsUrl,
		WEVERDAT_STREAMING: SiteConfigsData?.WeverdatStreamingUrl,
		KABADDIV_STREAMING: SiteConfigsData?.KabaddiVStreamingUrl
	}
	useEffect(() => {
		if (match?.MatchId !== streamingMatchId || (streamingType !== 'StaticInfo' && streamingUrl && !isRefresh) || (streamingType === 'StaticInfo' && streamingUrl)) {
			return;
		}
		if (streamingSrc === '18' || streamingType === 'StaticInfo') {
			switch (match?.GameID) {
				case 50:
					if (hasDecimalWidgets && STREAMING_URL_LIST['DECIMAL_WIDGETS']) {
						const dwmid = (match as CricketMatchModel).dwmid;
						setStreamingUrl(`${STREAMING_URL_LIST['DECIMAL_WIDGETS']}?id=${dwmid}&backgroundColor=%232c3e50&foregroundColor=%23ffffff&f`);
					} else if (STREAMING_URL_LIST['WEVERDAT_STREAMING']) {
						setStreamingUrl(STREAMING_URL_LIST['WEVERDAT_STREAMING'].replace('{0}', match.Sid) + '&w=563&h=557');
					}
					break;
				case 47:
					if (STREAMING_URL_LIST['KABADDIV_STREAMING']) {
						setStreamingUrl(STREAMING_URL_LIST['KABADDIV_STREAMING'].replace('{0}', match.Sid));
					}
					break;
			}

			setIsLoading(false);
		}
	}, [channelList, isRefresh, streamingSrc, streamingUrl, streamingMatchId]);

	return <StreamingBase />;
};

